const requestRegistrationData = state => {
  return {
    phone: state.phone,
  };
};

export default requestRegistrationData;
